import { render, staticRenderFns } from "./form-dynamic.vue?vue&type=template&id=28fe82ae&"
import script from "./form-dynamic.vue?vue&type=script&lang=js&"
export * from "./form-dynamic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/base/form-dynamic.vue
// module id = 122
// module chunks = 0